import React from 'react';
import { RunnerPageDescription } from '@Client/runner.directives/common/PageDescription';
import { CreationHubPicker } from './CreationHubPicker';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import { getService } from '@Client/runner.hooks/useService';
import FlowModelType from '@Shared.Angular/@types/core/contracts/constants/flowModelType';
import { BrandColor } from '@Shared.Angular/@types/brandColor';

export const CreateProcessMapHubPage = () => {
  const $state = getService('$state');
  const appConfig = getService('APP_CONFIG');
  return (
    <div className="create-process-map-hub-page creation-hub-page">
      <RunnerPageDescription
        showText={false}
        backLinkText="Back"
        backLinkState={STATE_MAPPINGS.creationHub}
      />
      <CreationHubPicker
        title="New Process Map"
        description="Pick how you'd like to create your process map."
        groups={[
          {
            title: 'Build Manually',
            color: BrandColor.Grey,
            label: 'No AI',
            items: [
              {
                iconClass: 'fa-pen-line',
                title: 'Build from Scratch',
                description:
                  'Build a process map from scratch using the drag-and-drop builder, with full control to customise every step.',
                color: BrandColor.Grey,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcessMapFromScratch, {
                    flowModelType: FlowModelType.ProcessMap
                  });
                }
              }
            ]
          },
          appConfig.enableFlowModelGeneration && {
            title: 'Build With AI',
            color: BrandColor.PrimaryBlue,
            label: 'AI',
            iconClass: 'fa-sparkles',
            items: [
              {
                iconClass: 'fa-file-lines',
                title: 'Generate from Text',
                description:
                  'Enter text, or upload an MD or TXT file, and AI will extract key steps to generate a process map.',
                color: BrandColor.PrimaryBlue,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcessMapFromText);
                }
              },
              {
                iconClass: 'fa-image',
                title: 'Generate from Image',
                description:
                  'Upload an image and AI will analyse the content, extract key steps and generate a process map.',
                color: BrandColor.PrimaryBlue,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcessMapFromImage);
                }
              },
              {
                iconClass: 'fa-table',
                title: 'Generate from CSV',
                description:
                  'Upload a CSV and AI will analyse the data, extract key steps and generate a process map.',
                color: BrandColor.PrimaryBlue,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcessMapFromCsv);
                }
              },
              {
                iconClass: 'fa-upload',
                title: 'Generate from Video',
                description:
                  'Upload an existing video and AI will extract key steps to generate a process map.',
                color: BrandColor.PrimaryBlue,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcessMapFromVideo);
                }
              },
              {
                iconClass: 'fa-file-audio',
                title: 'Generate from Audio',
                description:
                  'Upload an existing audio file and AI will generate a Process Map with steps, approvals, decision paths and form fields.',
                color: BrandColor.PrimaryBlue,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcessMapFromAudio);
                }
              },
              {
                iconClass: 'fa-video',
                title: 'Record Your Screen with AI',
                description:
                  'Record your screen and voice live with the desktop recorder, and AI will extract key steps to generate a process map.',
                color: BrandColor.PrimaryBlue,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcessMapFromRecording);
                }
              }
            ]
          }
        ]}
      />
    </div>
  );
};
